<script setup>
import { computed } from 'vue';
import EnTooltip from 'Components/base/EnTooltip/';

/**
 * Component props:
 *
 * @prop {string} title - The title of the label (required).
 * @prop {string} subtitle - The subtitle of the label.
 * @prop {string} tooltip - The tooltip of the label.
 * @prop {boolean} [dense] - If true, applies compact styling.
 */
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: String,
  tooltip: String,
  dense: Boolean
});
</script>

<template>
  <div class="en-small-labeled-content" :class="{ dense }">
    <en-tooltip :disabled="!tooltip" :text="tooltip ?? ''" position="top">
      <span class="en-small-labeled-content__title">{{ title }}</span>
    </en-tooltip>
    <div class="en-small-labeled-content__content">
      <!-- @slot The content of the label. -->
      <slot></slot>
    </div>
    <div class="en-small-labeled-content__subtitle" v-if="subtitle">{{ subtitle }}</div>
  </div>
</template>

<style lang="scss" scoped>
@use "Styles/helper/variables.scss";
@use "Styles/helper/mixins";

.en-small-labeled-content {
  &__title {
    margin-bottom: 0.7rem;
    font-size: variables.$font-size-default;
    color: variables.$en-60;
    width: auto;
  }

  &__content {
    margin-bottom: 0.7rem;
    font-size: variables.$font-size-input;
  }

  &__subtitle {
    margin-bottom: 0.7rem;
    font-size: variables.$font-size-default;
    color: variables.$en-40;
  }

  .dense & {
    &__title {
      margin-top: -13px;
    }

    &__content {
      margin-top: -9px;
    }
  }
}
</style>